import {Injectable} from '@angular/core';
import {Service} from '../../common/service.class';
import {Residency} from './residency.model';
import {UserModelListService} from '../../common/user-model-list.service';

/**
 * Created by Rodrigo Quesada on 04/12/16.
 */
@Injectable()
export class ResidencyService extends UserModelListService<Residency> {

    constructor(svcm: Service.InjectedMembers) {
        super(svcm, 'residency', Residency);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/education/residency/residency.service.ts